"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.Subtitle = exports.SessionListTile = exports.HorizontalSpacingContainer = exports.HorizontalGroup = exports.ColorDot = exports.ArrowImageContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../assets/styles/colors");
const media_1 = require("../../../../utils/media");
const Typography_1 = require("../../../atoms/Typography");
const SessionListTile = styled_components_1.default.div `
  cursor: pointer;
  background-color: ${colors_1.white};
  border-radius: 1rem;
  border: 1px solid ${colors_1.gray100};
  box-shadow: 0 0.4rem 0.8rem rgba(0, 0, 0, 0.1);
  padding: ${({ $isIndoor }) => ($isIndoor ? "0.6rem 1rem" : "0.5rem 1rem")};
  margin-right: 0.9375rem;
  margin-left: 0.9375rem;
  box-sizing: border-box;

  @media (${media_1.media.desktop}) {
    margin-right: 0rem;
    margin-left: 0rem;
    width: 230px;
  }
`;
exports.SessionListTile = SessionListTile;
const HorizontalSpacingContainer = styled_components_1.default.div `
  display: flex;
  align-items: left;
  justify-content: space-between;
  margin-top: ${({ $isIndoor }) => ($isIndoor ? "0.4rem" : "0.5rem")};
  margin-bottom: ${({ $isIndoor }) => ($isIndoor ? "0.6rem" : "0.8rem")};
`;
exports.HorizontalSpacingContainer = HorizontalSpacingContainer;
const HorizontalGroup = styled_components_1.default.div `
  display: flex;
  align-items: left;
`;
exports.HorizontalGroup = HorizontalGroup;
const ColorDot = styled_components_1.default.span `
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: ${(props) => props.$color};
  border-radius: 50%;
  margin-right: 0.8rem;
  border: ${(props) => (props.$isAvg ? "none" : `1px solid ${colors_1.gray200}`)};
`;
exports.ColorDot = ColorDot;
const Title = (0, styled_components_1.default)(Typography_1.H4) `
  text-align: left;
  font-weight: 500;
  margin-bottom: ${({ $isIndoor }) => ($isIndoor ? "0.6rem" : "0.8rem")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
exports.Title = Title;
const Subtitle = (0, styled_components_1.default)(Typography_1.H5) `
  text-align: left;
  margin-bottom: ${({ $isIndoor }) => ($isIndoor ? "0.6rem" : "0.8rem")};
`;
exports.Subtitle = Subtitle;
const ArrowImageContainer = styled_components_1.default.div `
  width: 1.5rem;
  height: 1.35rem;

  @media (${media_1.media.desktop}) {
    display: none;
  }
`;
exports.ArrowImageContainer = ArrowImageContainer;
